module.exports = __webpack_public_path__ + "static/media/default_tooltip_device.45698876.png";